import React, { useEffect, useState } from 'react'
import { Sidebar } from '../components/Layout/Sidebar'
import Topbar from '../components/Layout/Topbar'
import UserForm from '../CreateUser/UserForm'
import { useNavigate, useParams } from 'react-router-dom'
import * as XLSX from 'xlsx';
import EditUserForm from '../CreateUser/EditUserForm'
import { getUserProfile, updateUserProfile, uploadFile, getFileUrl } from '../supabase.config'
const EditUser = () => {
  const navigate = useNavigate("")
  const { id } = useParams()
  const [userInfo, setUserInfo] = useState({})
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [gstNo, setGstNo] = useState("")
  const [gstDocument, setGstDocument] = useState("")
  const [agreement, setAgreement] = useState("")
  const [otherDoc, setOtherDoc] = useState("")
  const [insuranceType, setInsuranceType] = useState("")
  const [contact, setContact] = useState("")
  const [companyAddress, setCompanyAddress] = useState("")
  const [rateChart, setRateChart] = useState(null)
  const [rateJson, setRateJson] = useState("")
  const handleCreateUser = async () => {
    const updates = {
      name,
      email,
      password,
      contact,
      company_name: companyName,
      gst_no: gstNo,
      gst_document: gstDocument,
      agreement,
      other_doc: otherDoc,
      insurance_type: insuranceType,
      company_address: companyAddress,
      wallet_balance: '',
      rate_list: rateJson,
    }

    const { error } = await updateUserProfile(id, updates)
    if (error) {
      alert(`Failed to update user: ${error.message || error}`)
      return
    }
    navigate("/users")
  }
  const addGSTInformation = async (e) => {
    e.preventDefault()
    const file = e.target[0]?.files[0]
    if (!file) return
    const path = `gst/${file.name}`
    const { error } = await uploadFile('documents', path, file)
    if (error) {
      alert(error.message || 'Failed to upload GST document')
      return
    }
    const downloadURL = getFileUrl('documents', path)
    setGstDocument(downloadURL)
  }

  const addAgreementInformation = async (e) => {
    e.preventDefault()
    const file = e.target[0]?.files[0]
    if (!file) return
    const path = `agreements/${file.name}`
    const { error } = await uploadFile('documents', path, file)
    if (error) {
      alert(error.message || 'Failed to upload Agreement document')
      return
    }
    const downloadURL = getFileUrl('documents', path)
    setAgreement(downloadURL)
  }
  const handleConvert = () => {
    if (rateChart) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        setRateJson(json);

      };

      reader.readAsBinaryString(rateChart);
      alert("Updated Rate List")
    }

  }

  const fetchUser = async () => {
    const { data, error } = await getUserProfile(id)
    if (error) {
      console.error('Failed to load user', error)
      return
    }
    setUserInfo(data)
    setName(data?.name || '')
    setEmail(data?.email || '')
    setRateJson(data?.rate_list || '')
    setContact(data?.contact || '')
    setCompanyName(data?.company_name || '')
    setCompanyAddress(data?.company_address || '')
    setGstNo(data?.gst_no || '')
    setGstDocument(data?.gst_document || '')
    setInsuranceType(data?.insurance_type || '')
    setAgreement(data?.agreement || '')
    setOtherDoc(data?.other_doc || '')
    setPassword(data?.password || '')
  }
  useEffect(() => {
    fetchUser()
  }, [id])

  return (
    <div className='bg-gray-100 flex '>
      <Sidebar />
      <div className='h-[100vh] overflow-y-scroll flex flex-1 flex-col '  >
        <Topbar />

        <EditUserForm name={name} setName={setName}
          rateChart={rateChart} setRateChart={setRateChart}
          rateJson={rateJson} setRateJson={setRateJson}
          handleConvert={handleConvert}
          addAgreementInformation={addAgreementInformation}
          addGSTInformation={addGSTInformation}
          handleCreateUser={handleCreateUser}
          companyAddress={companyAddress} setCompanyAddress={setCompanyAddress}
          email={email} setEmail={setEmail}
          password={password} setPassword={setPassword}
          companyName={companyName} setCompanyName={setCompanyName}
          gstNo={gstNo} setGstNo={setGstNo}
          agreement={agreement} setAgreement={setAgreement}
          gstDocument={gstDocument} setGstDocument={setGstDocument}
          otherDoc={otherDoc} setOtherDoc={setOtherDoc}
          insuranceType={insuranceType} setInsuranceType={setInsuranceType}
          contact={contact} setContact={setContact}
        />
      </div>
    </div>
  )
}

export default EditUser
